export default __webpack_public_path__ + "static/media/JOSA SYLLABUS_2026-27 CLASS 9.aa8416b9.pdf";